import React from 'react';
import { createRoot } from 'react-dom/client';

import mapboxgl from 'mapbox-gl';
import { Provider } from 'react-redux';
import App from './app';

import './i18n/config';
import './utils/extendDayjs';
import './index.css';
import 'react-phone-number-input/style.css';

import { store } from './redux/store';

mapboxgl.accessToken = import.meta.env.VITE_MAPBOX_ACCESS_TOKEN;

const container = document.getElementById('root');

if (container) {
  const root = createRoot(container);

  root.render(
    <React.StrictMode>
      <React.Suspense fallback={<span className="loading loading-spinner h-4 w-4"></span>}>
        <Provider store={store}>
          <App />
        </Provider>
      </React.Suspense>
    </React.StrictMode>,
  );
} else {
  throw new Error(
    "Root element with ID 'root' was not found in the document. Ensure there is a corresponding HTML element with the ID 'root' in your HTML file.",
  );
}
